import { useEffect, useRef, useState } from 'react';

import { GlobalPortal } from '@shared/ui/global-portal'; // ⬅️ используем готовый портал

import { HintProps } from './types';

import styles from './styles.module.scss';

export const Hint = ({ refParent, children }: HintProps) => {
	const [showHint, setShowHint] = useState(false);
	const hintRef = useRef<HTMLDivElement>(null);
	const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

	/* вычисление позиции */
	const setHintPosition = () => {
		const offset = 4;
		const parentEl = refParent.current;
		const hintEl = hintRef.current;
		if (!parentEl || !hintEl) return;

		const { clientHeight: winH, clientWidth: winW } = document.documentElement;
		const { top, left, width, height } = parentEl.getBoundingClientRect();
		const { width: hintW, height: hintH } = hintEl.getBoundingClientRect();
		const scrollX = window.pageXOffset;
		const scrollY = window.pageYOffset;

		let x = scrollX + left + width / 2 - hintW / 2;
		if (x < 0) x = offset;
		else if (x + hintW + offset > winW) x -= x + hintW + offset - winW;

		let y = scrollY + top + height + offset;
		if (top + height + offset + hintH > winH) {
			y = scrollY + top - hintH - offset;
		}

		hintEl.style.left = `${x}px`;
		hintEl.style.top = `${y}px`;
		hintEl.style.opacity = '1';
	};

	/* навешиваем/снимаем слушатели */
	useEffect(() => {
		const parentEl = refParent.current;
		if (!parentEl) return;

		const clearTimer = () => {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current);
				timeoutRef.current = null;
			}
		};

		const enter = () => {
			clearTimer();
			setShowHint(true);
			timeoutRef.current = setTimeout(setHintPosition, 400);
		};
		const leave = () => {
			setShowHint(false);
			clearTimer();
		};

		parentEl.addEventListener('mouseenter', enter);
		parentEl.addEventListener('mouseleave', leave);
		parentEl.addEventListener('click', leave);

		return () => {
			parentEl.removeEventListener('mouseenter', enter);
			parentEl.removeEventListener('mouseleave', leave);
			parentEl.removeEventListener('click', leave);
			clearTimer();
		};
	}, [refParent]);

	if (!showHint) return null;

	/* рендерим через готовый портал */
	return (
		<GlobalPortal>
			<div ref={hintRef} className={styles.Hint}>
				{children}
			</div>
		</GlobalPortal>
	);
};
